export function arraysAreEqual<T>(arr1: T[] = [], arr2: T[] = []) {
	if (arr1.length !== arr2.length) return false;

	const set2 = new Set(arr2);

	return arr1.every(item => set2.has(item));
}

// helper function similar to underscore’s pluck
export function pluck<T, K extends keyof T>(values: T[], by: K) {
	return Object.fromEntries(values.map(value => [value[by], value]));
}

export function groupBy<K extends PropertyKey, T>(
	data: T[] = [],
	keySelector: (item: T, index: number) => K
): Partial<Record<K, T[]>> {
	const group = {} as Partial<Record<K, T[]>>;

	data.forEach((item, index) => {
		const key = keySelector(item, index);
		group[key] ??= [];
		group[key].push(item);
	});

	return group;
}
export function objectKeys<T extends object>(obj: T): Array<keyof T> {
	return Object.keys(obj) as Array<keyof T>;
}

type Entries<T> = { [K in keyof T]: [K, T[K]] }[keyof T][];
export function ObjectTypedEntries<T extends Record<PropertyKey, unknown>>(
	obj: T
): { [K in keyof T]: [K, T[K]] }[keyof T][] {
	return Object.entries(obj) as Entries<T>;
}

/**
 * Takes a raw value index and coerces it to a number index, undefined or null.
 * This is used to prevent bad rows from being passed to snowplow on SnowplowTitleContext.
 */
export function coerceIndex(raw: unknown): number | null | undefined {
	if (raw == null || raw === '') return null;

	const coerced = Number(raw);
	if (Number.isNaN(coerced) || coerced < 0) return null;

	return coerced;
}
